import {useSelector} from "react-redux";
import TaskDelayReason from "./task-delay-reason";

export function useTaskDelayReason() {
    const {workspaceMembershipData} = useSelector(state => state.app);
    const workspaceId = workspaceMembershipData?.workspace?.id;

    const getDelayReasons = async () => {
        try {
            const model = new TaskDelayReason();
            const query = {
                filters: {
                    isActive: {$eq: true},
                    ...(workspaceId ? {workspaceId: {$eq: workspaceId}} : {}),
                },
                sort: ["sortOrder:asc", "title:asc"],
                pagination: {pageSize: 100, withCount: false},
            };
            const _data = await model.getAll(query);
            return _data?.data || [];
        } catch (e) {
            return [];
        }
    };

    const createDelayReason = async (reasonData) => {
        try {
            const model = new TaskDelayReason();
            const payload = {
                ...(workspaceId ? {workspaceId} : {}),
                title: reasonData?.title,
            };
            const _data = await model.createItem(payload, {populate: "*"});
            return _data?.data;
        } catch (e) {
            throw e;
        }
    };

    return {
        getDelayReasons,
        createDelayReason,
    };
}
